module.exports = __webpack_public_path__ + "img/venus-statue.17f1d9ac.png";